import React from "react";
import { Button } from "@material-ui/core";
import { useNavigate } from "react-router-dom";

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div style={{ textAlign: "center", marginTop: "10%" }}>
      <h1>🚫 Unauthorized Access</h1>
      <p>You don’t have permission to view this page.</p>
      <Button variant="contained" color="primary" onClick={() => navigate("/")}>
        Go to Login
      </Button>
    </div>
  );
};

export default Unauthorized;
